<template>
  <SkeletonItem
    :skeleton-style="{
      width: '100%',
      height: size,
      borderRadius: '16px',
    }"
    skeleton-class="skeleton-img"
  />
  <SkeletonItem
    :skeleton-style="{
      width: '100%',
      height: '24px',
      borderRadius: '6px',
    }"
    skeleton-class="skeleton-title"
  />
  <SkeletonItem
    :skeleton-style="{
      width: '100%',
      height: '20px',
      borderRadius: '6px',
    }"
    skeleton-class="skeleton-subtitle"
  />
</template>

<script setup lang="ts">
import { SkeletonItem } from '@experience/core-skeleton-lib';
import { computed } from 'vue';

import { useScreenSize } from '@/shared/utils/breakpoints';

const breakpoints = useScreenSize();

const size = computed(() => (breakpoints.isTablet.value || breakpoints.isMobile.value ? '170px' : '260px'));
</script>

<style lang="scss" scoped>
.skeleton-title {
  margin-top: var(--alias-space-6, 6px);
}
</style>
